import * as Sentry from "@sentry/browser";

import AutoloadContainer from "./frontend_modules/AutoloadContainer.js";
import ContentAutoloadContainer from "./frontend_modules/ContentAutoloadContainer.js";
import AutoloadFilter from "./frontend_modules/AutoloadFilter.js";
import EnumDropdown from "./frontend_modules/EnumDropdown.js";
import MediaCenter from "./frontend_modules/MediaCenter.js";
import Calendar from "./frontend_modules/FullCalendar.js";
import ActionButton from "./frontend_modules/ActionButton.js";
import ButtonToggle from "./frontend_modules/ButtonToggle.js";
import BFDropZone from "./frontend_modules/BFDropZone.js";
import PriceSelect from "./frontend_modules/PriceSelect.js";
import CheckboxSwitch from "./frontend_modules/CheckboxSwitch.js";
import CheckboxDarkModeSwitch from "./frontend_modules/CheckboxDarkModeSwitch.js";
import RadioButton from "./frontend_modules/RadioButton.js";
import InputFile from "./frontend_modules/InputFile.js";
import SubscriptionPlanForm from "./frontend_modules/SubscriptionPlanForm.js";
import ToggleVisibility from './frontend_modules/ToggleVisibility.js';
import BlurEvent from "./frontend_modules/BlurEvent.js";
import IntervalCheck from "./frontend_modules/IntervalCheck.js";

import ModalHandler from './frontend_modules/ModalHandler.js';
import TooltipHandler from "./frontend_modules/TooltipHandler";
import FormHandler from "./frontend_modules/FormHandler.js";
import Recaptcha from "./frontend_modules/Recaptcha.js";
import CheckboxGroup from "./frontend_modules/CheckboxGroup.js";
import socketMessenger from "./socketMessenger.js";
import DynamicDropdown from "./frontend_modules/DynamicDropdown.js";
import AutoReloadContainer from "./frontend_modules/AutoreloadContainer.js";

import InputCounter from "./frontend_modules/InputCounter.js";
import EmojiPicker from "./frontend_modules/EmojiPicker";
import ClickedReactionHandler from "./frontend_modules/ClickedReactionHandler.js";
import GifsHandler from "./frontend_modules/GifsHandler.js";
import ConversationSearch from "./frontend_modules/ConversationSearch.js";

import Address from "./frontend_modules/Address";

import PortalNotification from "./frontend_modules/PortalNotification.js";
import Cta from "./frontend_modules/Cta";
import VideoPlayer from "./frontend_modules/VideoPlayer";
import Gallery from "./frontend_modules/Gallery";
import AutoSizeImage from "./frontend_modules/AutoSizeImage";
import ImagePreloader from "./frontend_modules/ImagePreloader";
import VideoPreloader from "./frontend_modules/VideoPreloader";
import Collapse from "./frontend_modules/Collapse.js"
import Deleteable from "./frontend_modules/Deleteable"

import templatesWorker from "./templatesWorker.js";
import Poll from "./frontend_modules/Poll";
import VisibilitySelector from "./frontend_modules/VisibilitySelector";
import EmojisHandler from "./frontend_modules/EmojisHandler";
import ValueSelector from "./frontend_modules/ValueSelector";
import DateTimePickerHandler from "./frontend_modules/DateTimePickerHandler";
import PostingFormHandler from "./frontend_modules/PostingFormHandler";
import CheckboxCollapse from "./frontend_modules/CheckboxCollapse";
import TabHandler from "./frontend_modules/TabHandler";
import BestOffersHandler from "./frontend_modules/BestOffersHandler";
import RemovableListElement from "./frontend_modules/RemovableListElement";
import BackToTop from "./frontend_modules/BackToTop";
import PageSection from "./frontend_modules/PageSection";
import {CreatorRegistration} from "./frontend_modules/CreatorRegistration";
import {ClipboardButton} from "./frontend_modules/ClipboardButton";
import {DocumentFileInput} from "./frontend_modules/DocumentFileInput";
import AjaxSearch from "./frontend_modules/AjaxSearch";
import Shift4Form from "./frontend_modules/Shift4Form";
import InputRequiredError from "./frontend_modules/InputRequiredError";
import FilterHighlighter from "./frontend_modules/FilterHighlighter";
import InputVisibilityControl from "./frontend_modules/InputVisibilityControl";
import PageReloader from "./frontend_modules/PageReloader";
import DropdownAdjuster from "./frontend_modules/DropdownAdjuster";
import UserList from "./frontend_modules/UserList";
import LaravelEcho from "./frontend_modules/LaravelEcho";
import BaseClass from "./BaseClass";
import CreatorCamHandler from "./frontend_modules/CreatorCamHandler";
import UserCamHandler from "./frontend_modules/UserCamHandler";
import AdminCamHandler from "./frontend_modules/AdminCamHandler";
import {SocialiteLogin} from "./frontend_modules/SocialiteLogin";
import {PushSubscription} from "./frontend_modules/PushSubscription";
import {DigicertSiteSeal} from "./frontend_modules/DigicertSiteSeal";
import SubmitOnChange from "./frontend_modules/SubmitOnChange";
import ResizeHandler from "./frontend_modules/ResizeHandler";
import HomeCarousel from "./frontend_modules/HomeCarousel";
import StoriesAvatarScroll from "./frontend_modules/StoriesAvatarScroll";
import socketLiveCamChat from "./socketLiveCamChat";
import {PushSubscriptionModalHandler} from "./frontend_modules/PushSubscriptionModalHandler";
import {PushSubscriptionManager} from "./frontend_modules/PushSubscriptionManager";

window.jj = $;
window.Echo = null;

window.jj = $;
export default class frontEndWorker {

    static config = {
        google: {
            recaptcha: {
                standard: {apiUrl: 'https://www.google.com/recaptcha/api.js'},
                enterprise: {apiUrl: 'https://www.google.com/recaptcha/enterprise.js'}
            }
        },
        shift4: {
            apiUrl: 'https://js.dev.shift4.com/shift4.js'
        }
    };

    config = frontEndWorker.config;

    preventScroll = false;
    lastyScrollPosition = 0;

    init() {
        this.createIntersectionObserver();
        this.initSentry();
        this.objects = [];
        this.keyMap = [];
        this.templatesWorker = new templatesWorker();

        let mySelf = this;
        this.csrfToken = $('meta[name="csrf-token"]').attr('content');

        this.apis = {
            cookiebot: {
                ready: false,
                callbacks: {
                    ready: [],
                    accept: [],
                    decline: [],
                },
            },
            google: {
                recaptcha: {
                    standard: {},
                    enterprise: {}
                },
            },
            shift4: {
                requested: false,
                loaded: false,
                callbacks: [],
                client: null
            }
        };

        this.onShift4LoadedCb = function () {
            mySelf.onShift4Loaded();
        }

        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': this.csrfToken
            }
        });

        const debouncedTrackWindowScroll = debounce(function () {
            mySelf.trackWindowScroll();
        }, 50);
        const debouncedTrackWindowResize = debounce(function () {
            mySelf.trackWindowResize();
        }, 50);

        document.addEventListener('scroll', function () {
            if (mySelf.preventScroll && window.scrollY == 0) {
                // Bugfix für Video-Fullsreen-Bug in WebKit, Browser springt nach oben nach Fullscreen
                window.scrollTo(0, mySelf.lastyScrollPosition);

            } else {
                if (window.scrollY > 0) {
                    mySelf.lastyScrollPosition = window.scrollY;
                }
                debouncedTrackWindowScroll();
            }
        }, true);


        $(window).on('resize', function () {
                debouncedTrackWindowResize();
            }
        );

        $(document).on('click keydown touchstart', function () {
            $(document).trigger("user:interaction");
        });

        $(document).on("orientationchange", function () {
            debouncedTrackWindowResize();
        });

        $(document).on("show:loading", function () {
            mySelf.showLoading();
        });

        $(document).on("modal:open", function (event, data) {
            mySelf.openModal(data.contentUrl, data.contentData);
        });


        $(document).on("hide:loading", function () {
            mySelf.hideLoading();
        });

        $(document).on("content:loaded", function () {
            mySelf.initElements();
        });

        $(document).on("shown.bs.toast", function () {
            mySelf.initElements();
        });

        $(document).on("tooltip:init", function () {
            mySelf.initTooltipHandler();
        });

        $(document).on("modalhandler:init", function () {
            mySelf.initModalHandler();
        });

        $(document).on("toast:show", function (event, data) {
            mySelf.displayToast(data.title, data.subtitle, data.body, data.type, data.placement, data.delay, data.autohide);
        });

        $(document).on('google:recaptcha:api:load', $.proxy(this.onLoadGoogleRecaptchaApi, this));
        $(document).on('shift4:api:load', function (event, data) {
            mySelf.onLoadShift4Api(event, data);
        });

        $(document).on('fullscreenchange', function () {
            mySelf.onFullScreenChange();
        });

        $(document).on('mozfullscreenchange', function () {
            mySelf.onFullScreenChange();
        });
        $(document).on('msfullscreenchange', function () {
            mySelf.onFullScreenChange();
        });
        $(document).on('webkitfullscreenchange', function () {
            mySelf.onFullScreenChange();
        });

        $(window).on('keyup', function (event) {
            mySelf.removeBlurScreenshot(event);
        });

        $(window).on('keydown', function (event) {
            mySelf.setBlurScreenshot(event);
        });

        $(window).on('CookiebotOnConsentReady', $.proxy(this.onCookiebotOnConsentReady, this));
        $(window).on('CookiebotOnAccept', $.proxy(this.onCookiebotOnAccept, this));
        $(window).on('CookiebotOnDecline', $.proxy(this.onCookiebotOnDecline, this));

        if (Cookiebot?.consented || Cookiebot?.declined) {
            this.onCookiebotOnConsentReady();
        }

        this.disableContextMenu();
        this.initElements();
        this.initMessenger();

        this.initMutationObserver();
        this.initNavigation();
        this.setAppHeight();
        this.loadSystemAlerts();
    }

    initSentry() {

        return; // Vorerst deaktiviert

        if (process.env.SENTRY_DSN !== null) {
            Sentry.init({
                maxBreadcrumbs: 50,
                dsn: process.env.SENTRY_DSN,
                environment: process.env.SENTRY_ENVIRONMENT,
                integrations: [
                    Sentry.browserTracingIntegration(),
                    Sentry.replayIntegration()
                ],
                tracesSampleRate: process.env.SENTRY_TRACES_SAMPLE_RATE,
                replaysSessionSampleRate: process.env.SENTRY_REPLAY_SAMPLE_RATE,
                replaysOnErrorSampleRate: process.env.SENTRY_REPLAY_ONERROR_SAMPLE_RATE,
            });
        }
    }

    loadSystemAlerts() {
        const url = $('meta[name="bf:system_alert:url"]').attr('content');

        if (typeof url == 'undefined') {
            return;
        }

        $.post({
            url,
            dataType: 'json',
            success: function (data) {
                const baseClass = new BaseClass();

                baseClass.handleAjaxResponse(data);
            }
        });
    }

    removeBlurScreenshot(event) {
        let mySelf = this;
        let filter = 'blurred';

        if (event.key === 'PrintScreen') {
            this.setBlurScreenshot(event);
        }

        mySelf.keyMap = [];

        $('.autosizeimage').each(function () {
            setTimeout(() => {
                $(this).removeClass(filter);
            }, '1000');
        });
    }

    setBlurScreenshot(event) {
        let mySelf = this;
        let keyShift = false;
        let keyMeta = false;
        let keyPrint = false;
        let filter = 'blurred';

        mySelf.keyMap[mySelf.keyMap.length] = event.key;
        if (mySelf.keyMap.length > 0) {
            for (let i = 0; i < mySelf.keyMap.length; i++) {
                switch (mySelf.keyMap[i]) {
                    case 'Shift':
                        keyShift = true;
                        break;

                    case 'Meta':
                        keyMeta = true;
                        break;

                    case 'PrintScreen':
                        keyPrint = true;
                        break;
                }
            }

            if ((keyShift && keyMeta) || keyPrint) {
                $('.autosizeimage').each(function () {
                    $(this).addClass(filter);
                });
            }
        }
    }

    onFullScreenChange() {
        // Bugfix für Video-Fullsreen-Bug in WebKit, Browser springt nach oben nach Fullscreen
        let mySelf = this;

        let inFullScreen = Boolean(document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.msFullscreenElement);
        if (inFullScreen) {
            mySelf.preventScroll = true;
            setTimeout(function () {
                mySelf.preventScroll = false;
            }, 100);
        } else {
            if (window.scrollY != mySelf.yScrollPosition) {

                setTimeout(function () {
                    window.scrollTo({
                        top: mySelf.lastyScrollPosition,
                        left: 0,
                        behavior: "instant",
                    });
                }, 100);
            }
        }
    }

    intersectionAction(entries) {
        entries.forEach(function (entry) {
            let jsObject = entry.target.jsObject;
            if (jsObject != undefined && jsObject.handleVisibilityChange != undefined) {
                jsObject.handleVisibilityChange(entry.intersectionRatio, entry.isIntersecting);
            }
        });
    }

    createIntersectionObserver() {
        let mySelf = this;
        const options = {
            root: null,
            rootMargin: '50% 0% 400% 0%',
            threshold: [0, 0.1, 0.15, 0.2, 0.25, 0.3, 0.35, 0.4, 0.45, 0.5, 0.55, 0.6, 0.65, 0.7, 0.75, 0.8, 0.85, 0.9, 0.95]
        };

        this.intersectionObserver = new IntersectionObserver(this.intersectionAction, options);

        $(document).on("IntersectionObserver:observe", function (event, entry) {
            mySelf.trackVisibility(entry);
        });

        $(document).on("IntersectionObserver:unobserve", function (event, entry) {
            mySelf.untrackVisibility(entry);
        });

    }

    trackVisibility(entry) {
        this.intersectionObserver.observe(entry);
    }

    untrackVisibility(entry) {
        this.intersectionObserver.unobserve(entry);
    }

    onLoadGoogleRecaptchaApi(event, data) {
        if (data?.version != undefined && data?.render != undefined) {
            this.loadGoogleRecaptchaApi(data.version, data.render, data.callback);
        }
    }

    loadGoogleRecaptchaApi(version, render, callback) {
        if (this.apis.google.recaptcha[version][render] == undefined) {
            this.apis.google.recaptcha[version][render] = {
                requested: false,
                loaded: false,
                callbacks: []
            }
        }

        if (callback != undefined) {
            this.apis.google.recaptcha[version][render].callbacks.push(callback);
        }

        if (!this.apis.google.recaptcha[version][render].loaded) {
            if (this.apis.cookiebot.ready) {
                this.loadGoogleRecaptcha(version, render);
            } else {
                const self = this;

                this.apis.cookiebot.callbacks.ready.push(function () {
                    self.loadGoogleRecaptcha(version, render);
                });
            }
        } else {
            this.onGoogleRecaptchaApiLoaded(version, render);
        }
    }

    loadGoogleRecaptcha(version, render) {
        if (frontEndWorker.config.google.recaptcha[version]?.apiUrl == undefined || this.apis.google.recaptcha[version][render] == undefined) {
            return;
        }

        const self = this;

        const onLoadFunctionName = '__onGoogleRecaptchaLoaded__' + version + '__' + render;
        window[onLoadFunctionName] = function () {
            self.onGoogleRecaptchaApiLoaded(version, render);
        }

        const apiUrl = new URL(frontEndWorker.config.google.recaptcha[version].apiUrl);
        if (typeof document.head?.parentElement?.lang != "undefined") {
            apiUrl.searchParams.set('hl', document.head?.parentElement?.lang);
        }

        apiUrl.searchParams.set('render', render);
        apiUrl.searchParams.set('onload', onLoadFunctionName);

        if (Cookiebot?.consent?.necessary && !this.apis.google.recaptcha[version][render].requested) {
            this.apis.google.recaptcha[version][render].requested = true;

            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = apiUrl.toString();

            script.setAttribute('async', '');

            // defer if async unsupported
            script.setAttribute('defer', '');

            document.body.appendChild(script);
        }
    }

    onGoogleRecaptchaApiLoaded(version, render) {
        if (this.apis.google.recaptcha[version][render] == undefined) {
            return;
        }

        if (!this.apis.google.recaptcha[version][render].loaded) {
            this.apis.google.recaptcha[version][render].loaded = true;
        }

        for (const callback of this.apis.google.recaptcha[version][render].callbacks) {
            callback();
        }

        this.apis.google.recaptcha[version][render].callbacks.splice(0, this.apis.google.recaptcha[version][render].callbacks.length);
    }

    onLoadShift4Api(event, data) {
        if (!this.apis.shift4.requested) {
            this.apis.shift4.requested = true;

            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = frontEndWorker.config.shift4.apiUrl;

            script.onload = this.onShift4LoadedCb;

            document.body.append(script);
        }

        if (data?.callback != undefined) {
            if (!this.apis.shift4.loaded) {
                this.apis.shift4.callbacks.push(data.callback);
            } else {
                data.callback(this.apis.shift4.client);
            }
        }
    }

    onShift4Loaded() {
        this.apis.shift4.loaded = true;

        const key = $('meta[name="shift4_key"]').prop('content');

        this.apis.shift4.client = Shift4(key);

        for (const callback of this.apis.shift4.callbacks) {
            callback(this.apis.shift4.client);
        }

        this.apis.shift4.callbacks.splice(0, this.apis.shift4.callbacks.length);
    }

    onCookiebotOnConsentReady() {
        // console.log('onCookiebotOnConsentReady', this, arguments);
        this.apis.cookiebot.ready = true;

        for (const callback of this.apis.cookiebot.callbacks.ready) {
            callback();
        }

        this.apis.cookiebot.callbacks.ready.splice(0, this.apis.cookiebot.callbacks.ready.length);
    }

    onCookiebotOnAccept() {
        for (const callback of this.apis.cookiebot.callbacks.accept) {
            callback();
        }

        this.apis.cookiebot.callbacks.accept.splice(0, this.apis.cookiebot.callbacks.accept.length);
        this.apis.cookiebot.callbacks.decline.splice(0, this.apis.cookiebot.callbacks.decline.length);
    }

    onCookiebotOnDecline() {
        for (const callback of this.apis.cookiebot.callbacks.decline) {
            callback();
        }

        this.apis.cookiebot.callbacks.accept.splice(0, this.apis.cookiebot.callbacks.accept.length);
        this.apis.cookiebot.callbacks.decline.splice(0, this.apis.cookiebot.callbacks.decline.length);
    }

    displayToast(title, subtitle, body, type, placement, delay, autohide) {
        let $toast = this.templatesWorker.getTemplate('js-toast_tpl');
        let toastID = this.generateRandomString(10);

        if (typeof subtitle == 'undefined') {
            subtitle = '';
        }

        $toast.attr('id', toastID);
        $toast.find('.toast-title').html(title);
        $toast.find('.toast-subtitle').html(subtitle);
        $toast.find('.toast-body').html(body);

        let $toastsContainer;
        switch (placement) {
            case 'bottom':
                $toastsContainer = $('[data-type="toastcontainerbottom"]');
                break;
            case 'top':
                $toastsContainer = $('[data-type="toastcontainertop"]');
                break;
            case 'end-bottom':
                $toastsContainer = $('[data-type="toastcontainerendbottom"]');
                break;
            case 'middle':
            default:
                $toastsContainer = $('[data-type="toastcontainermiddle"]');
        }

        switch (type) {
            case 'secondary':
                $toast.find('.toast-rect').attr('fill', '#F6AD47');
                break;
            case 'error':
                $toast.find('.toast-rect').attr('fill', '#FF0000');
                if (typeof delay == 'undefined') {
                    delay = 10000;
                }
                break;

            case 'warning':
                $toast.find('.toast-rect').attr('fill', '#F4E607');
                if (typeof delay == 'undefined') {
                    delay = 5000;
                }
                break;

            case 'confirmation':
                $toast.find('.toast-rect').attr('fill', '#4BAA10');
                if (typeof delay == 'undefined') {
                    delay = 2000;
                }
                break;

            case 'notice':
                $toast.find('.toast-rect').attr('fill', '#C2ECA8');
                if (typeof delay == 'undefined') {
                    delay = 2000;
                }
                break;
        }

        if (typeof delay != 'undefined') {
            $toast.attr('data-bs-delay', delay);
        }
        if (typeof autohide != 'undefined') {
            $toast.attr('data-bs-autohide', autohide);
        }

        $toastsContainer.append($toast);

        $('#' + toastID).toast("show");
        $('#' + toastID).on("hidden.bs.toast", function () {
            $toast.remove();
        });
    }

    generateRandomString(length) {
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let result = '';
        const charactersLength = characters.length;
        for (let i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }

        return result;
    }

    disableContextMenu() {
        document.addEventListener("contextmenu", function (event) {

            if ($(event.target).is('img')) {
                let position = window.location.href.search('admin');
                if (position == -1) {
                    event.preventDefault();
                }
            }

        }, false);
    }

    trackWindowScroll() {
        $(document).trigger("content:scrolled");
        $(document).trigger("user:interaction");
        this.initElements();
    }

    trackWindowResize() {
        $(document).trigger("content:resized");
        document.dispatchEvent(new Event('visibilitychange'));
        this.initElements();
        this.setAppHeight();

    }

    setAppHeight() {
        const doc = document.documentElement;
        let availableHeight = document.documentElement.clientHeight;

        let heights = {
            document: $(document).height(),
            navBar: $('#nav-bar').innerHeight(),
            navBarBottom: $('#nav-bar-bottom-container').innerHeight() || 0,
            messengerHeader: $('.messenger-header').innerHeight() || 0,
            settingsMenu: $('#nav-menu__settings').innerHeight() || 0,
            window: $(window).innerHeight(),
        };

        let viewPortHeight = heights.window - heights.navBar;
        if (heights.document <= heights.window) {
            viewPortHeight = heights.window - heights.navBar;
        }
        doc.style.setProperty('--app-height', availableHeight + 'px');
        doc.style.setProperty('--full-height', viewPortHeight + 'px');
        doc.style.setProperty('--height-nav-bar', heights.navBar + 'px');
        doc.style.setProperty('--height-nav-bar-bottom', heights.navBarBottom + 'px');
        doc.style.setProperty('--height-header-bar', heights.messengerHeader + 'px');
        doc.style.setProperty('--height-nav-menu__settings', heights.settingsMenu + 'px');
    }

    initElements() {
        this.initEchoChannels();
        this.initResponsiveHeader();
        this.initModalHandler();
        this.initTooltipHandler();
        this.initCollapse();
        this.initClipboardButton();
        this.initFormHandler();
        this.initRecaptcha();
        this.initCheckboxGroup();
        this.initSubmitOnChange();
        this.initActionButtons();
        this.initAutoloadContainer();
        this.initContentAutoloadContainer();
        this.initAutoreloadContainer();
        this.initAutoloadFilter();
        this.initVisibilitySelector();
        // initAutocomplete();
        this.initVideoPlayer();
        this.initPoll();
        this.initCta();
        this.initGallery();
        this.initToggleVisibility();
        this.initDeleteable();
        this.initDropZone();
        this.initForms();
        this.initEnumDropdown();
        this.initMediaCenter();
        this.initCalendar();
        this.initButtonToggle();
        this.initCheckboxCollapse();
        this.initPortalNotification();
        this.initPopover();
        this.initAutoSizeImage();
        this.initCheckboxSwitch();
        this.initCheckboxDarkModeSwitch();
        this.initInputVisibilityControl();
        this.initRadioButton();
        this.initSubscriptionPlanForm();
        this.initImagePreloader();
        this.initVideoPreloader();
        this.initSocialButtons();
        this.initPushSubscription();
        this.initPushSubscriptionModalHandler();
        this.initPushSubscriptionManager();
        this.initValueSelector();
        this.initBlurEvent();
        this.initBackToTop();
        this.initDigicertSiteSeal();
        this.inputRequiredError();
        this.initFilterHighlighter();
        this.initEmojisInput();
        this.initPostingFormHandler();
        this.initTabHandler();
        this.initPageSections();
        this.initBestOffersHandler();
        this.initCreatorRegistrationHandler();
        this.initRemovableListElements();
        this.initAutoScrollContent();
        this.initIntervalCheck();
        this.initPageReloader();
        this.initDropdownAdjuster();
        this.initHomeCarousel();
        this.initIsSamsungBrowser();
        this.initUserList();
        this.initStoriesAvatarScroll();
        this.initLiveCamChat();
        this.initCreatorCamHandler();
        this.initUserCamHandler();
        this.initAdminCamHandler();

    }

    initResponsiveHeader() {
        const $profileHeaderSticky = $('[data-type="profileheadersticky"]');
        const $scrollPos = $(document).scrollTop();

        if ($profileHeaderSticky.length > 0) {
            if ($scrollPos > 100) {
                $profileHeaderSticky.addClass('profile-header--sticky-shrink');
            } else {
                $profileHeaderSticky.removeClass('profile-header--sticky-shrink');
            }
        }
    }

    initEchoChannels() {
        let mySelf = this;
        $('[data-type="echo-channel"][data-state="init"]').each(function () {
            mySelf.objects.push(new LaravelEcho(this));
        });
    }

    initEmojisInput() {
        let mySelf = this;
        $('[data-type="emojishandler"][data-state="init"]').each(function () {
            mySelf.objects.push(new EmojisHandler(this));
        });
    }

    initPostingFormHandler() {
        let mySelf = this;
        $('[data-type="postingformhandler"][data-state="init"]').each(function () {
            mySelf.objects.push(new PostingFormHandler(this));
        });
    }

    initCreatorCamHandler() {
        let mySelf = this;
        $('[data-type="creator-cam-handler"][data-state="init"]').each(function () {
            mySelf.objects.push(new CreatorCamHandler(this));
        });
    }

    initUserCamHandler() {
        let mySelf = this;
        $('[data-type="user-cam-handler"][data-state="init"]').each(function () {
            mySelf.objects.push(new UserCamHandler(this));
        });
    }

    initAdminCamHandler() {
        let mySelf = this;
        $('[data-type="admin-cam-handler"][data-state="init"]').each(function () {
            mySelf.objects.push(new AdminCamHandler(this));
        });
    }


    initNavigation() {
        const debounceNavClick = debounce(function () {

            $('#nav-hamburger').toggleClass('nav-hamburger--open');
            $('#nav-menu').toggleClass('nav-menu--open');
        }, 250, {
            'leading': true,
            'trailing': false
        });

        const debounceSettingsClick = debounce(function () {

            $('#nav-settings').toggleClass('nav-settings--open');
            $('.settings-container__inner').toggleClass('visible');
            $('#nav-menu__settings').toggleClass('nav-menu__settings--open');

        }, 250, {
            'leading': true,
            'trailing': false
        });

        $('[data-type="mainnavbutton"]').on('click', debounceNavClick);
        $('[data-type="settingsbutton"]').on('click', debounceSettingsClick);

    }

    initDropZone() {
        $('[data-type="dropzone"][data-state="init"]').each(function () {
            let BFDropZoneObj = new BFDropZone(this);
        });

    }

    initAutoSizeImage() {
        let mySelf = this;
        $('[data-type="autosizeimage"][data-state="init"]').each(function () {
            mySelf.objects.push(new AutoSizeImage(this));
        });
    }

    initVisibilitySelector() {
        let mySelf = this;
        $('[data-type="visibilityselector"][data-state="init"]').each(function () {
            mySelf.objects.push(new VisibilitySelector(this));
        });
    }

    initImagePreloader() {
        let mySelf = this;
        $('[data-type="imagepreloader"][data-state="init"]').each(function () {
            mySelf.objects.push(new ImagePreloader(this));
        });
    }

    initVideoPreloader() {
        let mySelf = this;
        $('[data-type="videopreloader"][data-state="init"]').each(function () {
            mySelf.objects.push(new VideoPreloader(this));
        });
    }

    initSocialButtons() {
        let mySelf = this;
        $('[data-type="socialite-login"][data-state="init"]').each(function () {
            mySelf.objects.push(new SocialiteLogin(this));
        })
    }

    initPushSubscription() {
        let mySelf = this;
        $('[data-type="push-subscription"][data-state="init"]').each(function () {
            mySelf.objects.push(new PushSubscription(this));
        })
    }

    initPushSubscriptionModalHandler() {
        let mySelf = this;
        $('[data-type="push-subscription-modal-handler"][data-state="init"]').each(function () {
            mySelf.objects.push(new PushSubscriptionModalHandler(this));
        })
    }

    initPushSubscriptionManager() {
        let mySelf = this;
        $('[data-type="push-notification-manager"][data-state="init"]').each(function () {
            mySelf.objects.push(new PushSubscriptionManager(this));
        })
    }

    initIntervalCheck() {
        let mySelf = this;
        $('[data-type="intervalcheck"][data-state="init"]').each(function () {
            mySelf.objects.push(new IntervalCheck(this));
        });
    }

    initPageReloader() {
        let mySelf = this;
        $('[data-type="page-reloader"][data-state="init"]').each(function () {
            mySelf.objects.push(new PageReloader(this));
        });
    }

    initDropdownAdjuster() {
        let mySelf = this;
        $('[data-type="dropdown-adjuster"][data-state="init"]').each(function () {
            mySelf.objects.push(new DropdownAdjuster(this));
        });
    }

    initUserList() {
        let mySelf = this;
        $('[data-type="user-list"][data-state="init"]').each(function () {
            mySelf.objects.push(new UserList(this));
        });
    }

    initStoriesAvatarScroll() {
        let mySelf = this;
        $('[data-type="stories-avatar-scroll"][data-state="init"]').each(function () {
            mySelf.objects.push(new StoriesAvatarScroll(this));
        });
    }

    initCheckboxSwitch() {
        let mySelf = this;
        $('[data-type="checkboxswitch"][data-state="init"]').each(function () {
            mySelf.objects.push(new CheckboxSwitch(this));
        });
    }

    initCheckboxDarkModeSwitch() {
        let mySelf = this;
        $('[data-type="checkboxdarkswitch"][data-state="init"]').each(function () {
            mySelf.objects.push(new CheckboxDarkModeSwitch(this));
        });
    }

    initInputVisibilityControl() {
        let mySelf = this;
        $('[data-type="input-visibility-control"][data-state="init"]').each(function () {
            mySelf.objects.push(new InputVisibilityControl(this));
        });
    }

    initRadioButton() {
        let mySelf = this;
        $('[data-type="radiobutton"][data-state="init"]').each(function () {
            mySelf.objects.push(new RadioButton(this));
        });
    }

    initValueSelector() {
        let mySelf = this;
        $('[data-type="valueselector"][data-state="init"]').each(function () {
            mySelf.objects.push(new ValueSelector(this));
        });
    }

    initSubscriptionPlanForm() {
        let mySelf = this;
        $('[data-type="subscription-plan-form"][data-state="init"]').each(function () {
            mySelf.objects.push(new SubscriptionPlanForm(this));
        });
    }

    initAutoloadFilter() {
        $('[data-type="autoloadfilter"][data-state="init"]').each(function () {
            let AutoloadFilterObj = new AutoloadFilter(this);
        });
    }

    initEnumDropdown() {
        $('[data-type="enum-dropdown"][data-state="init"]').each(function () {
            let enumDropdown = new EnumDropdown(this);
        });
    }

    initButtonToggle() {
        $('[data-type="button-toggle"][data-state="init"]').each(function () {
            let buttonToggle = new ButtonToggle(this);
        });
    }

    initCheckboxCollapse() {
        $('[data-type="checkbox-collapse"][data-state="init"]').each(function () {
            let checkboxCollapse = new CheckboxCollapse(this);
        });
    }

    initFormHandler() {

        $('[data-type="form"][data-state="init"]').each(function () {
            let container = new FormHandler(this);
        });
    }

    initRecaptcha() {
        let mySelf = this;
        $('[data-type="recaptcha"][data-state="init"]').each(function () {
            mySelf.objects.push(new Recaptcha(this));
        });
    }

    initCheckboxGroup() {
        $('[data-type="checkbox-group-setter"][data-state="init"]').each(function () {
            let container = new CheckboxGroup(this);
        });
    }

    initSubmitOnChange() {
        $('[data-type="submit-on-change"][data-state="init"]').each(function () {
            let container = new SubmitOnChange(this);
        });
    }

    initActionButtons() {
        let mySelf = this;
        $('[data-type="actionbutton"][data-state="init"]').each(function () {
            mySelf.objects.push(new ActionButton(this));
        });
    }

    initAutoloadContainer() {
        let mySelf = this;
        $('[data-type="autoload"][data-state="init"]').each(function () {
            mySelf.objects.push(new AutoloadContainer(this));
        });
    }

    initContentAutoloadContainer() {
        let mySelf = this;
        $('[data-type="content-autoload"][data-state="init"]').each(function () {
            mySelf.objects.push(new ContentAutoloadContainer(this));
        });
    }

    initAutoreloadContainer() {
        $('[data-type="autoreload"][data-state="init"]').each(function () {
            let container = new AutoReloadContainer(this);
        });
    }


    initPoll() {
        $('[data-type="poll"][data-state="init"]').each(function () {
            let element = new Poll(this);
        });
    }

    initCta() {
        $('[data-type="cta"][data-state="init"]').each(function () {
            let element = new Cta(this);
        });
    }

    initVideoPlayer() {
        $('[data-type="videoplayer"][data-state="init"]').each(function () {
            let player = new VideoPlayer(this);
        });
    }

    initGallery() {
        $('[data-type="gallery"][data-state="init"]').each(function () {
            let gallery = new Gallery(this);
        });
    }


    initPortalNotification() {
        $('[data-type="portalnotification"][data-state="init"]').each(function () {
            let element = new PortalNotification(this);
        });
    }

    initBlurEvent() {
        $('[data-type="blurevent"][data-state="init"]').each(function () {
            let element = new BlurEvent(this);
        });
    }

    initAutoScrollContent() {
        $('[data-type="auto-scroll-content"][data-state="init"]').each(function () {
            let element = new AutoScrollContent(this);
        });
    }


    initBackToTop() {
        $('[data-type="back_to_top"][data-state="init"]').each(function () {
            let backToTop = new BackToTop(this);
        });
    }

    initDigicertSiteSeal() {
        $('[data-type="digicert_siteseal"][data-state="init"]').each(function () {
            let digicertSiteSeal = new DigicertSiteSeal(this);
        });
    }

    inputRequiredError() {
        $('[data-validation="input-required"][data-state="init"]').each(function () {
            let inputRequiredError = new InputRequiredError(this);
        });
    }

    initFilterHighlighter() {
        let mySelf = this;

        $('[data-type="filter-highlighter"][data-state="init"]').each(function () {
            mySelf.objects.push(new FilterHighlighter(this));
        });
    }

    initForms() {
        let mySelf = this;
        $('[data-type="priceSelect"][data-state="init"]').each(function () {
            let element = new PriceSelect(this);
        });

        $('[data-type="address"][data-state="init"]').each(function () {
            let element = new Address(this);
        });
        $('[data-type="shift4-form"][data-state="init"]').each(function () {
            let element = new Shift4Form(this);
        });
        $('[data-type="inputcounter"][data-state="init"]').each(function () {
            mySelf.objects.push(new InputCounter(this));
        });
        $('[data-type="inputfile"][data-state="init"]').each(function () {
            mySelf.objects.push(new InputFile(this));
        });
        $('[data-type="document-file-input"][data-state="init"]').each(function () {
            mySelf.objects.push(new DocumentFileInput(this));
        });

        $('[data-type="emojipicker"][data-state="init"]').each(function () {
            let element = new EmojiPicker(this);
        });

        $('[data-type="clickedreactionhandler"][data-state="init"]').each(function () {
            let element = new ClickedReactionHandler(this);
        });

        $('[data-type="gifshandler"][data-state="init"]').each(function () {
            let element = new GifsHandler(this);
        });

        $('[data-type="dynamic-dropdown"][data-state="init"]').each(function () {
            let element = new DynamicDropdown(this);
        });

        $('[data-type="conversation-search-container"][data-state="init"]').each(function () {
            let element = new ConversationSearch(this);
        });

        $('[data-type="ajax-search"][data-state="init"]').each(function () {
            let element = new AjaxSearch(this);
        });

        $('[data-type="resize-handler"][data-state="init"]').each(function () {
            mySelf.objects.push(new ResizeHandler(this));
        });


        // $('[data-type="editform"][data-state="init"]').each(function () {
        //     let form = new EditForm(this);
        // });
        // $('[data-type="createform"][data-state="init"]').each(function () {
        //     let form = new CreateForm(this);
        // });


    }

    initMessenger() {
        let messenger = new socketMessenger();
    }

    initLiveCamChat() {
        const self = this;
        $('[data-type="camchat"][data-state="init"]').each(function () {
            self.objects.push(new socketLiveCamChat(this));
        });
    }

    initModalHandler() {
        $('[data-type="modalhandler"][data-state="init"]').each(function () {
            let modal = new ModalHandler(this);
        });
    }

    openModal(contentUrl, contentData) {
        // Hier muss noch das Aufräumen der EventListener überlegt werden
        let modal = new ModalHandler(null, contentUrl, contentData);
        modal.loadModal();
    }

    initTooltipHandler() {
        $('[data-type="tooltip"][data-state="init"]').each(function () {
            let tooltip = new TooltipHandler(this);
        });

        $('[data-type="datetimepicker"][data-state="init"]').each(function () {
            let tooltip = new DateTimePickerHandler(this);
        });


    }

    initCollapse() {
        $('[data-type="collapse"][data-state="init"]').each(function () {
            let collapse = new Collapse(this);
        });
    }

    initClipboardButton() {
        const self = this;
        $('[data-type="clipboard-button"][data-state="init"]').each(function () {
            self.objects.push(new ClipboardButton(this));
        });
    }

    initPopover() {
        // Vorerst deaktiviert
        // $('[data-type="popover"][data-state="init"]').each(function () {
        //     console.error(this);
        //     let popover = new Popover(this);
        // });
    }


    initToggleVisibility() {
        let mySelf = this;
        $('[data-type="togglevisibility"][data-state="init"]').each(function () {
            mySelf.objects.push(new ToggleVisibility(this));
        });
    }

    initDeleteable() {
        $('[data-type="deleteable"][data-state="init"]').each(function () {
            let element = new Deleteable(this);
        });
    }

    showLoading() {
        $('#loading').removeClass('hidden');
    }

    hideLoading() {
        $('#loading').addClass('hidden');
    }

    initTabHandler() {
        let mySelf = this;
        $('[data-type="nav_tab"][data-state="init"]').each(function () {
            let tabHandler = new TabHandler(this); // Nicht bootstrap variante
        });
    }

    initPageSections() {
        let mySelf = this;
        $('[data-type="page_section"][data-state="init"]').each(function () {
            let tabHandler = new PageSection(this);
        });
    }

    initBestOffersHandler() {
        let mySelf = this;
        $('[data-type="bestoffershandler"][data-state="init"]').each(function () {
            mySelf.objects.push(new BestOffersHandler(this));
        });
    }

    initCreatorRegistrationHandler() {
        let mySelf = this;
        $('[data-type="creatorregistration"][data-state="init"]').each(function () {
            mySelf.objects.push(new CreatorRegistration(this));
        });
    }

    initRemovableListElements() {
        let mySelf = this;
        $('[data-type="removableListElement"][data-state="init"]').each(function () {
            mySelf.objects.push(new RemovableListElement(this));
        });
    }

    initMediaCenter() {
        $('[data-type="media-center"][data-state="init"]').each(function () {
            let mediaCenter = new MediaCenter(this);
        });
    }

    initCalendar() {
        $('[data-type="full-calendar"][data-state="init"]').each(function () {
            let fullCalendar = new Calendar(this);
        });
    }

    initHomeCarousel() {
        let mySelf = this;
        $('[data-type="homeCarousel"][data-state="init"]').each(function () {
            mySelf.objects.push(new HomeCarousel(this));
        });
    }

    initIsSamsungBrowser() {
        if (navigator.userAgent.includes('SamsungBrowser')) {
            document.documentElement.classList.add('is-samsung');
        }
    }

    initMutationObserver() {
        let mySelf = this;
        let mutationObserver = new MutationObserver(function (mutations) {
            mySelf.onMutation(mutations);
        });

        mutationObserver.observe(document.body, {childList: true, subtree: true});
    }

    onMutation(mutations) {

        let mySelf = this;
        let addedNodesCount = 0;

        for (const mutation of mutations) {
            for (const removedNode of mutation.removedNodes) {
                this.runTeardown(removedNode);
            }
            if (mutation.addedNodes.length > 0) {
                addedNodesCount += mutation.addedNodes.length;
            }
        }
        if (addedNodesCount > 0) {
        }
    }

    runTeardown(removedNode) {

        let mySelf = this;

        let $removedDataTypes = $(removedNode).find('[data-type]');

        if ($removedDataTypes.length > 0) {
            $removedDataTypes.each(function () {
                let obsoleteObject = this.jsObject;
                if (obsoleteObject !== undefined) {
                    mySelf.removeObsoleteObject(obsoleteObject);
                }
            });
        }

        if ($(removedNode).attr("data-type") != undefined) {
            // Es handelt sich um unser CustomObjekt, direkt aufräumen
            $(removedNode).each(function () {
                let obsoleteObject = this.jsObject;
                if (obsoleteObject !== undefined) {
                    mySelf.removeObsoleteObject(obsoleteObject);
                }
            });
        }
    }

    removeObsoleteObject(obsoleteObject) {

        if (obsoleteObject.destroyListener !== undefined) {
            obsoleteObject.destroyListener();
        }
        for (const prop of Object.getOwnPropertyNames(obsoleteObject)) {
            delete obsoleteObject[prop];
        }
        obsoleteObject = null;
    }
}
$(function () {
    let frWorker = new frontEndWorker();
    frWorker.init();
});

// Workaround für die nichtssagende Fehler im Instagram-Browser
window._AutofillCallbackHandler = window._AutofillCallbackHandler || function () {
}